import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import colorArray from "../../helpers/colorArray"
import _ from "lodash"
import { loadingStatus, loadingStatusMessage } from "actions"
import axios from "axios"
import settings from "settings"
import { HorizontalBar, Bar, Pie } from "react-chartjs-2"
import numeral from "numeral"
import moment from "moment"
import FullTable from "components/FullTable"
import ImageExport from "components/ImageExport"
import helpers from "helpers/helpers"

class Prospects extends Component {
	constructor(props) {
		super(props)
		this.state = {
			hideFlags: {
				originalSource: null,
			},
			data: {
				contacts: [],
				first: [],
			},
			filtered: [],
			sorted: [],
			columns: [
				{
					Header: "First Name",
					accessor: "First Name",
					filterMethod: (f, r) => helpers.tableText(f, r, "First Name"),
				},
				{
					Header: "Last Name",
					accessor: "Last Name",
					filterMethod: (f, r) => helpers.tableText(f, r, "Last Name"),
				},
				{
					Header: "Email",
					accessor: "Email",
					filterMethod: (f, r) => helpers.tableText(f, r, "Email"),
				},
				{
					Header: "Original Source",
					accessor: "Original Source",
					filterMethod: (f, r) => helpers.tableText(f, r, "Original Source"),
				},
				{
					Header: "First Conversion Source",
					accessor: "First Conversion Source",
					filterMethod: (f, r) => helpers.tableText(f, r, "First Conversion Source"),
				},
				{
					Header: "Created Date",
					accessor: "Created Date",
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
				},
			],
			available: false,
			notConnected: false,
		}
	}

	componentDidMount() {
		this.getData()
	}

	componentDidUpdate(prevProps) {
		if (!_.isEqual(this.props.currentDates, prevProps.currentDates)) {
			this.getData()
		} else if (!_.isEqual(this.props.activeProperties, prevProps.activeProperties)) {
			this.getData()
		}
	}

	getData = () => {
		this.props.loadingStatusMessage("Pulling data from CRM.  This may take a few minutes.")
		this.props.loadingStatus(true)
		let userToken = localStorage.getItem("user")
		axios
			.post(
				settings.ep + "/getProspects",
				{
					property: this.props.activeProperties[0],
					dates: this.props.currentDates,
				},
				{
					headers: { Authorization: `Bearer ${userToken}` },
				}
			)
			.then((resp) => {
				this.props.loadingStatusMessage("")
				if (resp.data.status == 400) {
					this.setState({ data: {}, available: false, notConnected: false }, () =>
						this.props.loadingStatus(false)
					)
					this.props.loadingStatus(false)
				} else if (_.has(resp, `data.data.status`) && _.isEqual(resp.data.data.status, 200)) {
					this.setState(
						{
							data: resp.data.data,
							available: true,
							notConnected: false,
						},
						() => {
							this.props.loadingStatus(false)
						}
					)
				} else if (_.has(resp, "data.data.status") && resp.data.data.status == 300) {
					this.setState({ notConnected: true }, () => this.props.loadingStatus(false))
				} else {
					this.setState({ data: {}, available: false, notConnected: false }, () =>
						this.props.loadingStatus(false)
					)
				}
			})
	}

	buildTable = () => {
		let ret = []
		_.forEach(this.state.data.contacts, (v) => {
			let original = _.replace(v.properties.hs_analytics_source, "_", " ")
			original = _.capitalize(original)
			let createdAt = moment(v.createdAt).unix()
			ret.push({
				"First Name": _.capitalize(v.properties.firstname),
				"Last Name": _.capitalize(v.properties.lastname),
				Email: v.properties.email,
				"Original Source": original,
				"First Conversion Source": v.properties.first_conversion_event_name,
				"Created Date": createdAt,
			})
		})

		return ret
	}

	originalSource = () => {
		let store = {}
		_.forEach(this.state.data.contacts, (v) => {
			let source = _.replace(v.properties.hs_analytics_source, "_", " ")
			source = _.capitalize(source)
			if (!_.has(store, source)) {
				_.set(store, source, 0)
			}
			store[source]++
		})
		const data = {
			labels: _.keys(store),
			datasets: [
				{
					data: _.values(store),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}
		return (
			<>
				<h3 className="statBox__title">Original Source</h3>
				<div id="gender">
					<Pie data={data} options={opts} />
				</div>
			</>
		)
	}

	formTypes = () => {
		if (!_.has(this.state, `data.formTypes.total`)) return ""

		const data = {
			labels: _.keys(this.state.data.formTypes.total),
			datasets: [
				{
					data: _.values(this.state.data.formTypes.total),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}
		return (
			<>
				<h3 className="statBox__title">Form Types</h3>
				<div id="gender">
					<Pie data={data} options={opts} />
				</div>
			</>
		)
	}

	firstInquiry = () => {
		if (!_.has(this.state, `data.formTypes.first`)) return ""

		const data = {
			labels: _.keys(this.state.data.formTypes.first),
			datasets: [
				{
					data: _.values(this.state.data.formTypes.first),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}
		return (
			<>
				<h3 className="statBox__title">First Form Inquiry Type</h3>
				<div id="gender">
					<Pie data={data} options={opts} />
				</div>
			</>
		)
	}

	render() {
		if (this.props.activeProperties.length == 0 || this.props.activeProperties.length > 1) {
			return (
				<div className="lotStatus__pleaseChoose">
					<h1>Please choose one community to view analytics.</h1>
				</div>
			)
		} else if (this.state.notConnected) {
			return (
				<div className="lotStatus__pleaseChoose">
					<h1>Community currently is not hooked into CRM.</h1>
				</div>
			)
		} else if (this.props.payloadStatus && this.state.available) {
			return (
				<div className="analytics">
					<div className="imageGroup">
						<Title title="Prospects" />
						<div className="content">
							<h1 className="title">
								{numeral(this.state.data.contacts.length).format("0,00")} Contacts
							</h1>
							<div className="statBox">
								<div className="statBox__row statBox__row--double">
									<div className="statBox__box avoid">
										<ImageExport name="OriginalSource" />
										{this.originalSource()}
									</div>
									<div className="statBox__box avoid">
										<ImageExport name="FormTypes" />
										{this.formTypes()}
									</div>
								</div>
								<div className="statBox__row statBox__row--double">
									<div className="statBox__box avoid">
										<ImageExport name="FirstInquiry" />
										{this.firstInquiry()}
									</div>
								</div>
							</div>
							<h2>Contact Details</h2>
							<FullTable
								data={this.buildTable()}
								columns={this.state.columns}
								name="prospects"
								title="Prospects"
							/>
						</div>
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			loadingStatusMessage,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(Prospects)
